import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-lineitem-header',
  templateUrl: './lineitem-header.component.html',
  styleUrls: ['./lineitem-header.component.scss']
})
export class LineitemHeaderComponent implements OnInit {

  header: UntypedFormControl = new UntypedFormControl('', [Validators.required]);
  constructor(
    public dialogRef: MatDialogRef<LineitemHeaderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  submitForm(): void {
    this.header.markAllAsTouched();
    if(this.getError()){
      return;
    }
    this.dialogRef.close(this.header?.value);
  }

  getError(): string{
    if(this.header.touched && this.header.invalid) {
      return 'text.field_is_required';
    }else{
      return '';
    }
  }

  ngOnInit(): void {
    if(this.data?.data?.header){
      this.header.setValue(this.data?.data?.header);
    }
  }

}
